import { useGebruikerContext } from "Pages/Coordinator/Gebruikers/Context/GebruikerContext";
import { useContext, createContext, useState, useEffect, useCallback } from "react";
import { toast } from "react-toastify";
import moment from "moment";
import { useUrenoverzichtData } from "Api/Coordinator/Gebruikers/Common/Urenoverzicht";

export const UrenoverzichtContext = createContext();

export const useUrenoverzichtContext = () => {
	const context = useContext(UrenoverzichtContext);

	if (!context) throw new Error("Use urenoverzicht context within provider.");
	return context;
};

export const UrenoverzichtProvider = ({ children }) => {
	const { currentUser, adminCommunityList, setFilterCommunity, filterCommunity } =
		useGebruikerContext();

	const [dropdownOpen, setDropdownOpen] = useState(false);
	const [hoursData, setHoursData] = useState();
	const [loading, setIsLoading] = useState(false);
	const [startDate, setStartDate] = useState("");
	const [endDate, setEndDate] = useState("");
	const toggle = () => setDropdownOpen((prevState) => !prevState);

	const communitySelectedIds =
		filterCommunity.length === adminCommunityList.length
			? "all"
			: filterCommunity.map((item) => item.iCommunityId).join(",");

	const adminId = currentUser?.data?.clooserId;

	const { data: urenoverzichtData, isLoading } = useUrenoverzichtData(
		startDate ? moment(startDate).format("DD-MM-YYYY") : "",
		endDate ? moment(endDate).format("DD-MM-YYYY") : "",
		adminId,
		communitySelectedIds
	);

	const handleCheckboxChange = (event) => {
		const communityId = Number(event.target.value);
		const communityName = event.target.name;
		if (
			filterCommunity?.length === 1 &&
			filterCommunity.some((item) => item.iCommunityId === communityId)
		) {
			toast.info("Je moet minimaal 1 bord selecteren.");
			return;
		}

		setFilterCommunity((prevOptions) => {
			const exists = prevOptions.some((item) => item.iCommunityId === communityId);
			if (exists) {
				return prevOptions.filter((item) => item.iCommunityId !== communityId);
			} else {
				return [
					...prevOptions,
					{ iCommunityId: communityId, vCommunityName: communityName },
				];
			}
		});
	};

	const intiDates = async () => {
		const date = new Date();
		const currentDate = moment(date).format("MM/DD/yyyy");
		let year = date.getFullYear();
		let endDate2 = "";
		let beginDate = "08/01/" + year;

		if (currentDate < beginDate) {
			year = date.getFullYear() - 1;
		}
		beginDate = "08/01/" + year;
		let nextYear = year + 1;
		endDate2 = "07/31/" + nextYear;
		setStartDate(beginDate);
		setEndDate(endDate2);
	};

	useEffect(() => {
		if (urenoverzichtData?.status) {
			setHoursData(urenoverzichtData.data);
		}
	}, [urenoverzichtData]);
	
	useEffect(() => {
		if (startDate === "" && endDate === "") {
			intiDates();
		}
	}, [startDate, endDate]);

	return (
		<UrenoverzichtContext.Provider
			value={{
				loading,
				startDate,
				endDate,
				hoursData,
				dropdownOpen,
				toggle,
				setStartDate,
				setEndDate,
				handleCheckboxChange,
			}}
		>
			{children}
		</UrenoverzichtContext.Provider>
	);
};
